<div class="edit-container">
    <h1 class="edit-title">Actualizează Document Oficial</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <!-- Only for data type 1 -->
        <div *ngIf="data.hasDocOfficial" class="row p-1">
            <div class="col-md-6">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Cod CAEN</mat-label>
                    <input matInput type="number" formControlName="obiect_activitate" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="fill">
                    <mat-label>Valabilitate</mat-label>
                    <input matInput [matDatepicker]="pickerValabil" formControlName="valability"
                        (dateChange)="onDateChange($event)" readonly (focus)="pickerValabil.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                    <mat-datepicker #pickerValabil></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <!-- For all data types -->
        <ng-container *ngIf="data.document_generabil_dual">
            <br />
            <div>
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event)"
                    value="toPrimarie">
                    <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
                    <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
                    <mat-button-toggle value="toate">Toate</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <br />
        </ng-container>
        <div class="row">
            <div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
                <br />
                <div class="col">
                    <h2 class="fw-bold">Exemplar Semnatari</h2>
                    <br />
                    <angular-editor class="fit-screen" formControlName="content"
                        [config]="editorConfig"></angular-editor>
                </div>
            </div>
            <div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
                <br />
                <div class="col">
                    <h2 class="fw-bold">Exemplar Primar</h2>
                    <br />
                    <angular-editor class="fit-screen" formControlName="content_citizen"
                        [config]="editorConfig"></angular-editor>
                </div>
            </div>
        </div>

        <br />

        <div class="row">
            <div class="col">
                <div class="d-flex justify-content-end">
                    <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                        {{ helper.dialogConfig.buttonLabels.close }}
                    </button>
                    <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                        {{ helper.dialogConfig.buttonLabels.save }}
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>